import { createFileRoute } from '@tanstack/react-router'

interface ICompaniesSearch {
  page?: number
  name?: string
  sortBy?: string
  sortDir?: 'asc' | 'desc'
}

export const Route = createFileRoute('/_authenticated/companies')({
  staticData: { title: 'Companies' },
  validateSearch: (search: Record<string, unknown>): ICompaniesSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
    name: typeof search.name === 'string' && search.name.length > 0 ? search.name : undefined,
    sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
    sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
  }),
})
